"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgRamblerMail = function SvgRamblerMail(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z",
    fill: "#2F5BF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.8,
    width: 21,
    height: 14,
    rx: 0.5,
    fill: "url(#RamblerMail_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.217 8.888 9.94 9.388a.5.5 0 0 0 .686 0l9.94-9.388A.498.498 0 0 0 25.5 8.8h-20a.498.498 0 0 0-.283.088Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04.002 3.13 30.319a5.96 5.96 0 0 1-.787-.662C0 27.314 0 23.542 0 16 0 8.457 0 4.686 2.343 2.343 4.474.213 7.786.02 14.041.002Z",
    fill: "#649DFF"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "RamblerMail_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 13.8 -20.7001 0 15.5 9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E2FF"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgRamblerMail);
var _default = exports["default"] = Memo;